<template>
  <div>
    <h2 class="text-xl font-bold mb-4">Selecciona la entrevista predefinida</h2>
    <select v-model="selectedInterview" class="w-full p-2 border rounded">
      <option v-for="interview in predefinedInterviews" :key="interview.id" :value="interview">
        {{ interview.Entrevista }}
      </option>
    </select>

    <div class="mt-4 flex justify-between" v-if="predefinedInterviews.length">
      <button class="bg-gray-200 hover:bg-gray-300 text-gray-700 font-bold py-2 px-4 rounded" @click="$emit('prev')">Anterior</button>
      <button v-if="selectedInterview" @click="showModal=true" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">Siguiente</button>
    </div>

    <div v-if="showModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
      <div class="bg-white p-8 rounded-md shadow-lg w-full max-w-md relative">
        <h2 class="text-2xl font-bold mb-4">Descripción de la Entrevista</h2>
        <p class="mb-4">{{ selectedInterview.Descripción }}</p>
        <div class="flex justify-between">
          <button class="bg-gray-200 hover:bg-gray-300 text-gray-700 font-bold py-2 px-4 rounded" @click="showModal=false">Atrás</button>
          <button @click="startInterview" class="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded">Comenzar Entrevista</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
    emits: ['next', 'prev', 'close'],
    props: ['setPredefinedInterview','setInterviewType', 'setChatSessionId', 'setInterviewCodeGenerated'],
    data() {
        return {
             showModal: false,
            selectedInterview: null,
            predefinedInterviews: []
        }
    },
    watch:{
        selectedInterview(newValue){
            this.setPredefinedInterview(newValue);
        }
    },
     async mounted() {
        try {
          const response = await axios.get(`/api/predefined-interviews`);
          this.predefinedInterviews = response.data;
            console.log("Predefined interviews", this.predefinedInterviews);
        } catch (error) {
            console.error("Error al obtener las entrevistas predefinidas:", error);
            alert("Error al obtener las entrevistas predefinidas. Por favor, intenta de nuevo más tarde.");
        }
    },
    methods: {
        async startInterview() {
             this.showModal = false;
            try {
              const response = await axios.post(`/api/start-predefined-interview`, { interview: this.selectedInterview });
                 this.setChatSessionId(response.data.chatSessionId);
                  this.setInterviewCodeGenerated(response.data.newChatSession);
                   this.setInterviewType("predefined");
                    this.$emit('close');

             } catch (error) {
                console.error("Error al iniciar la entrevista predefinida:", error);
                alert("Error al iniciar la entrevista predefinida. Por favor, intenta de nuevo más tarde.");
            }
          }
    }
}
</script>